import classNames from 'classnames'
import React from 'react'
import './form-options.scss'

/**
 * The props
 */
export interface FormOptionsProps<Value extends string> {
    /**
     * All values
     */
    values: [...Value[]]

    /**
     * The value
     */
    value: Value

    /**
     * Callback for when the value changes
     */
    onChange: (value: Value) => void
}

/**
 * A boolean in a form.
 * 
 * @author Stan Hurks
 */
export default class FormOptions<Value extends string> extends React.Component<FormOptionsProps<Value>> {
    public render = () => {
        return (
            <div className="form-options">
                {
                    this.props.values.map((v) => (
                        <div className="form-options-option" style={{
                            width: `${100 / this.props.values.length}%`
                        }} key={v}>
                            <div className={classNames({
                                'form-options-option-button': true,
                                'selected': this.props.value === v
                            })} onClick={() => {
                                this.props.onChange(v)
                            }}>
                                {
                                    v
                                }
                            </div>
                        </div>
                    ))
                }
            </div>
        )
    }
}